import React, { useEffect, useRef, useState } from "react";
import { Collapse, TableCell, TableRow } from "@material-ui/core";
// *** OJO: SON DOS COMPONENTES DISTINTOS. ***
// `StyledTableCell` es la celda de MUI y IGNORA `show`. El que lo implementa es
// `StyledTableCellProps` (le pone `display:none`), que es el que usa `SortableCell` en el
// thead. Importar el otro deja las celdas siempre visibles, sin ningún error: el header se
// oculta y la fila no, y la tabla queda corrida.
import { StyledTableCellProps as StyledTableCell } from "../../../commons/utils/TableStyles";
import MovilesInmovilizadosDetail from "./MovilesInmovilizadosDetail";
import { buildMovilesInmovilizadosColumns } from "./movilesInmovilizadosColumns.js";
import * as Utils from '../../../commons/utils/Utils';
import { FormattedMessage } from "react-intl";

/**
 * @param esVisible       (name) => bool, del hook de la grilla. Las celdas se renderizan en el
 *                        MISMO orden que el thead, que recorre la misma lista de columnas.
 *
 *                        Se oculta con `show` y NO desmontando la celda, que es la convención
 *                        del resto de las grillas (`StyledTableCell` le pone `display:none`).
 *                        Mezclar los dos mecanismos deja el header con más celdas que la fila.
 * @param columnasVisibles cuántas se están mostrando: es el `colSpan` de la fila de detalle.
 */
const MovilesInmovilizadosRow = ({ inmovilizadosPorBase, filters, esVisible, columnasVisibles }) => {
    const [open, setOpen] = useState(false);
    const [porcParalizados, setPorcParalizados] = useState(0);
    const [moviles, setMoviles] = useState([]);
    const dataObtenida = useRef(false);

    useEffect(() => {
        const porcentajeParalizados = parseFloat((100 * parseFloat(inmovilizadosPorBase.inmovilizados)) / parseFloat(inmovilizadosPorBase.total)).toFixed(2);
        setPorcParalizados(porcentajeParalizados);
    }, [inmovilizadosPorBase]);

    useEffect(() => {
        if (open && !dataObtenida.current) {
            getMovilesInmovilizadosPorDominio();
        }
    }, [open]);

    const getMovilesInmovilizadosPorDominio = () => {
        if (inmovilizadosPorBase.dominios.length === 0) {
            return;
        }
        Utils.getData(`/moviles-inmovilizados/porDominios/${inmovilizadosPorBase.dominios.join(',')}?
                        servicio=${filters.servicio}&tipoDeTicket=${filters.tipoDeTicket}`)
            .then((res) => {
                setMoviles(res);
                dataObtenida.current = true;
            })
    }


    // El valor de cada columna, por nombre. `porcentajeParalizadas` no viene del backend: se
    // calcula acá, así que no puede salir de `inmovilizadosPorBase` directamente.
    const valores = {
        base: inmovilizadosPorBase.base,
        gerenciador: inmovilizadosPorBase.gerenciador,
        total: inmovilizadosPorBase.total,
        inmovilizados: inmovilizadosPorBase.inmovilizados,
        porcentajeParalizadas: porcParalizados,
    };

    return (
        <>
            <TableRow>
                {/* La fila recorre LA MISMA lista que el thead, así agregar o reordenar una
                    columna no puede desfasarlos. Región va aparte, antes del map, porque lleva el
                    chevron que abre el detalle: por eso es `fixed` y no se puede ocultar. */}
                <StyledTableCell>
                    <div className="d-flex align-items-center">
                        <div onClick={() => setOpen(!open)}>
                            {open ? (
                                <i className="fa fa-2x fa-angle-double-down personal-no-focus avatar-plus-detail pointer"></i>
                            ) : (
                                <i className="fa fa-angle-double-right fa-2x personal-no-focus avatar-plus-detail pointer"></i>
                            )}
                        </div>
                        <div>
                            <span style={{ position: 'relative', top: '-3px', left: '3px' }}>
                                {inmovilizadosPorBase.region}
                            </span>
                        </div>
                    </div>
                </StyledTableCell>
                {buildMovilesInmovilizadosColumns()
                    .filter((columna) => columna.name !== 'region')
                    .map((columna) => (
                        <StyledTableCell key={columna.name} show={esVisible(columna.name)} align="left">
                            {valores[columna.name]}
                        </StyledTableCell>
                    ))}
            </TableRow>
            <TableRow>
                {/* El colSpan sigue a las columnas visibles: con uno fijo, al ocultar columnas la
                    fila de detalle se pasa de largo y corre la tabla. */}
                <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0, background: 'rgb(244, 245, 250)' }}
                    colSpan={columnasVisibles}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        {inmovilizadosPorBase.dominios.length > 0 ?
                            (<MovilesInmovilizadosDetail
                                moviles={moviles} />) :
                            (
                                <StyledTableCell align="center" colSpan={2}>
                                    <FormattedMessage id="moviles_inmovilizados.detail.no_results" defaultMessage="No results found" />
                                </StyledTableCell>
                            )
                        }
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}

export default MovilesInmovilizadosRow;